import { IModificationInfo } from 'types/creationDetails'
import { EProcurementPlanChangeReason } from 'types/procurementPlans/procurementPlanLogs'
import { IProcurementPlanItem } from 'types/procurementPlans/procurementPlanItems'
import { IPaginationInfo } from 'types/pagination'

export enum EProcurementPlanStatus {
  // CREATED = 'CREATED',
  PLANNING = 'PLANNING',
  MODIFIED = 'MODIFIED',
  PUBLISHED = 'PUBLISHED',
}

export interface IProcurementPlanCorrelation {
  id: string
  correlationId: string
  status: EProcurementPlanStatus
  publishedAt: string
  updatedAt: string
  version: number
}

export interface ICurrentProcurementPlan extends IModificationInfo {
  id: string
  correlationId: string
  year: number
  archived: boolean
  status: EProcurementPlanStatus
  publishedAt: string
  updatedAt: string
  changeReason: EProcurementPlanChangeReason
  reasonDescription: string
  creationOrderDate: String
  version: number
  previousVersionId: string
  creationOrderFileId: string
  organizationId: string
  organizationName: string
  procurementPlanItems: IProcurementPlanItem[]
}

export interface IProcurementPlan extends IModificationInfo {
  id: string
  correlationId: string
  name: string
  year: number
  archived: boolean
  status: EProcurementPlanStatus
  changeReason: EProcurementPlanChangeReason
  reasonDescription: string
  creationOrderDate: string
  creationOrderFileId: string
  version: number
  previousVersionId: string
  procurementPlanItems: IProcurementPlanItem[]
  updatedAt: string | null
  publishedAt: string | null
  organizationName?: string
}

export type IProcurementPlans = {
  info: IPaginationInfo
  items: IProcurementPlan[]
}
